type GtagCommand = 'config' | 'event' | 'js' | 'set';
type GtagParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (command: GtagCommand, target: string | Date, params?: GtagParams) => void;
  }
}

const GA_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID?.trim();

let lastTrackedPagePath: string | null = null;

function isGoogleAnalyticsEnabled(): boolean {
  return Boolean(
    GA_MEASUREMENT_ID?.startsWith('G-') &&
    typeof window !== 'undefined' &&
    typeof window.gtag === 'function'
  );
}

export function trackPageView(path: string): void {
  if (!isGoogleAnalyticsEnabled()) return;

  const url = new URL(path, window.location.origin);
  const pagePath = `${url.pathname}${url.search}`;
  if (pagePath === lastTrackedPagePath) return;

  lastTrackedPagePath = pagePath;
  window.gtag?.('event', 'page_view', {
    page_location: url.toString(),
    page_path: pagePath,
    page_title: document.title,
  });
}

export function trackEvent(name: string, params: GtagParams = {}): void {
  if (!isGoogleAnalyticsEnabled()) return;
  window.gtag?.('event', name, params);
}
